import { Component, inject, Signal } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { SlideFromRightContainerComponent } from '../../animation/slide-from-right-container/slide-from-right-container.component';

@Component({
	selector: 'app-toast',
	templateUrl: './toast.component.html',
	styleUrl: './toast.component.scss',
	imports: [SlideFromRightContainerComponent],
})
export class ToastComponent {
	private readonly toastService: ToastService = inject(ToastService);

	public type: Signal<string> = this.toastService.type;
	public showToast: Signal<boolean> = this.toastService.showToast;
	public message: Signal<string> = this.toastService.message;

	public closeClickHandler(): void {
		this.toastService.hide();
	}
}
